/**
 * DataBest — Plan-hierarchy API clients (individuals, plans, outcomes, activities, tasks).
 */
import api from "@/lib/axios";

const buildCRUD = (base) => ({
    list: (params) => api.get(base, { params }).then((r) => r.data),
    get: (id) => api.get(`${base}/${id}`).then((r) => r.data),
    create: (data) => api.post(base, data).then((r) => r.data),
    update: (id, data) => api.patch(`${base}/${id}`, data).then((r) => r.data),
    remove: (id) => api.delete(`${base}/${id}`).then((r) => r.data),
});

export const individualsApi = buildCRUD("/individuals");
export const plansApi = {
    ...buildCRUD("/plans"),
    // Slim listing: strips heavy JSONB payload (isp_parsed_json etc.) so the
    // Individual detail page renders instantly even in production.
    listSlim: (params) =>
        api
            .get("/plans", {
                params: { ...(params || {}), slim: true },
                timeout: 60000,
            })
            .then((r) => r.data),
    tree: (planId) =>
        api.get(`/plans/${planId}/tree`, { timeout: 60000 }).then((r) => r.data),
    deactivate: (planId) =>
        api.post(`/plans/${planId}/deactivate`).then((r) => r.data),
    ispUpload: (planId, file) => {
        const fd = new FormData();
        fd.append("file", file);
        return api
            .post(`/plans/${planId}/isp-upload`, fd, {
                headers: { "Content-Type": "multipart/form-data" },
            })
            .then((r) => r.data);
    },
    ispParseStart: (planId) =>
        api.post(`/plans/${planId}/isp-parse`).then((r) => r.data),
    ispParsedGet: (planId) =>
        api.get(`/plans/${planId}/isp-parsed`).then((r) => r.data),
    ispApply: (planId, tree, replaceExisting = false, forceDeleteMeasurements = false) =>
        api
            .post(`/plans/${planId}/isp-apply`, {
                tree,
                replace_existing: replaceExisting,
                force_delete_measurements: forceDeleteMeasurements,
            })
            .then((r) => r.data),
};
export const outcomesApi = buildCRUD("/outcomes");
export const activitiesApi = buildCRUD("/activities");
export const tasksApi = buildCRUD("/tasks");
